export function centralPerformanceRoute(pathname: string) {
  const path = (pathname.split("?")[0] ?? "/").replace(/\/+$/, "") || "/";
  if (/^\/workspace\/[^/]+$/.test(path)) return path;
  if (/^\/cases\/[^/]+/.test(path)) return path.replace(/^\/cases\/[^/]+/, "/cases/:caseId");
  if (/^\/events\/[^/]+/.test(path)) return path.replace(/^\/events\/[^/]+/, "/events/:eventId");
  return path.slice(0, 80);
}

export function centralMetricValue(value: number) {
  return Number.isFinite(value) && value >= 0 ? Math.round(value) : null;
}
